import React, { useEffect, useState } from 'react';
import { Avatar, Button } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import './listaEmpleados.css';

function EmpleadoAvatar({ nombre }) {
  const [imgError, setImgError] = useState(false);

  const imgSrc = `/fotos/${nombre}.png`;

  if (imgError || !nombre) {
    const iniciales = nombre
      .split(' ')
      .map(n => n.charAt(0))
      .join('')
      .toUpperCase();

    return (
      <Avatar sx={{ bgcolor: '#6c757d' }}>
        {iniciales}
      </Avatar>
    );
  }

  return (
    <Avatar
      alt={nombre}
      src={imgSrc}
      onError={() => setImgError(true)}
      sx={{ bgcolor: '#6c757d' }}
    />
  );
}

function ListaEmpleados({ onSeleccionEmpleado }) {
  const [empleados, setEmpleados] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/empleados`)
      .then(response => response.json())
      .then(data => {
        setEmpleados(data);
      })
      .catch(error => console.error('Error al obtener empleados:', error));
  }, []);

  const handleImprimir = () => {
    window.print();
  };

  const handleAñadirEmpleado = () => {
    alert('Aquí se abriría el formulario para añadir un nuevo empleado.');
  };

  return (
    <div className="lista-empleados-container">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <Button variant="outlined" startIcon={<PrintIcon />} onClick={handleImprimir}>
          Imprimir
        </Button>
        <Button variant="contained" startIcon={<PersonAddIcon />} onClick={handleAñadirEmpleado}>
          Añadir Empleado
        </Button>
      </div>

      <table className="table table-hover">
        <thead className="table-light">
          <tr>
            <th>Foto</th>
            <th>Nombre</th>
            <th>DNI</th>
            <th>Correo</th>
            <th>Teléfono</th>
            <th>Login</th>
            <th>Registro</th>
          </tr>
        </thead>
        <tbody>
          {empleados.map(emp => (
            <tr
              key={emp.id_empleado}
              onClick={() => onSeleccionEmpleado(emp)}
              style={{ cursor: 'pointer' }}
            >
              <td>
                <EmpleadoAvatar nombre={emp.nombre} />
              </td>
              <td>
                <div>
                  <div>{emp.nombre} {emp.apellido}</div>
                  <div style={{ fontSize: '0.8rem', color: '#555' }}>Peluquero</div>
                </div>
              </td>
              <td>{emp.dni}</td>
              <td>{emp.correo}</td>
              <td>{emp.telefono}</td>
              <td>{emp.id_login_empleado}</td>
              <td>{new Date(emp.fecha_registro).toLocaleDateString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ListaEmpleados;
